import Vue from "vue";
import VueRouter from "vue-router";
// import i18n from "../plugins/i18n";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   redirect: `/${i18n.locale}`,
  // },

  {
    path: "/",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "/",
        meta: { transitionName: "slide" },
        name: "home",
        component: () => import("@/views/home/index.vue"),
        // beforeEnter: (to, from, next) => {
        //   if (!store.state.auth.isAuth) next();
        //   else {
        //     if (localStorage.getItem("bitrahAccessToken")) {
        //       next(`/${i18n.locale}/panel/user/dashboard`);
        //     }
        //     if (localStorage.getItem("bitrahAdminAccessToken")) {
        //       next(`/${i18n.locale}/panel/admin/transactions`);
        //     }
        //   }
        // }
      },
      {
        path: "plugins",
        meta: { transitionName: "slide" },
        name: "plugins",
        component: () => import("@/views/plugins/index.vue"),
      },
      {
        path: "documents",
        meta: { transitionName: "slide" },
        name: "documents",
        component: () => import("@/views/document/index.vue"),
      },
      {
        path: "payment-demo",
        meta: { transitionName: "slide" },
        name: "payment-demo",
        component: () => import("@/views/plugins/index.vue"),
      },
      {
        path: "terms",
        meta: { transitionName: "slide" },
        name: "terms",
        component: () => import("@/views/terms/index.vue"),
      },
      // {
      //   path: "blog",
      //   meta: { transitionName: "slide" },
      //   name: "blog",
      //   component: () => import("@/components/home/blogs/qrcode.vue"),
      // },
      {
        path: "*",
        redirect: { name: "home" },
        // meta: { transitionName: "slide" },
        // name: "notfound",
        // component: () => import("../pages/notFound/qrcode.vue")
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   let language = to.params.lang;
//   if (!(language === "fa" || language === "en")) {
//     i18n.locale = "fa";
//     next({ name: to.name, params: { lang: "fa" } });
//   } else {
//     i18n.locale = language;
//     next();
//   }
// });

export default router;
